import React from 'react';

export default function createElement(Component, props) {
    const passedProps = props.route.props ? props.route.props : {};
    const component = <Component {...props} {...passedProps} />;

    return component;
}
